import React, { useState } from 'react';
import BoxWrapper from '../boxwra';
import Box from '@mui/material/Box';

import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function Eighteen({ reconId: propReconId, handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName, setTableName] = useState("18. HSN wise summary of Inward Supplies");
  const [value, setValue] = React.useState('1');
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Helper function to safely parse values for calculations
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0; // Return 0 for incomplete values during typing
    }

    // Convert to string to safely use string methods
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0; // Return 0 for incomplete decimal values during typing
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatRupee = (value, isManualInput = true) => {
    // For manual input fields, show empty if no value or zero
    if (isManualInput && (!value || value === '' || value === '0' || value === '0.00' || parseFloat(value) === 0)) {
      return '';
    }

    // For calculated/subtotal rows, always show formatted value (but empty if no value)
    if (!value && value !== 0) return '';

    // Only format if there's actually a value
    const numValue = parseFloat(value);
    if (numValue === 0 && isManualInput) return '';

    // For manual input, don't add .00 if it's a whole number
    if (isManualInput) {
      if (numValue % 1 === 0) {
        return `₹${numValue.toString()}`;
      } else {
        return `₹${numValue.toString()}`;
      }
    }

    return `₹${numValue.toFixed(2)}`;
  };

  const parseRupee = (value) => {
    if (!value) return '';
    // Allow only digits, one decimal point, and optional leading negative sign
    let cleaned = value.replace(/[^0-9.-]/g, '');
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    // Ensure only one negative sign at the beginning
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');

    // Clean the input value but allow intermediate states like "-", "5.", etc. for numeric fields
    const cleanedValue = ['taxable_value', 'igst', 'cgst', 'sgst', 'cess'].includes(field) ? parseRupee(value) : value;

    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );

    // Force re-render to update calculated subtotals when any manual input changes
    // setTimeout(() => {
    //   setTableData((prev) => [...prev]);
    // }, 0);
  };

  const submitHandle = () => {
    updateTableData(tableName, tableData);
    setUnsavedChanges(false);
    setSaveDailogOpen(false);
    setSnackbarOpen(true);
  };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle()
    handleBack()
  };

    const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };


  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isManualInputRow = true; // All rows are editable in Eighteen

      return (
        <div
          key={index}
          style={{
            display: 'grid',
            gridTemplateColumns: '60px 120px 200px 80px 120px 150px 200px 120px 150px 120px 120px 120px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '1px solid #f1f5f9',
            // backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
          }}
        >
          <span
            style={{
              color: '#1e293b',
              fontSize: '13px',
              fontWeight: '600',
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: getRowColor(index),
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {index + 1}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.hsn_sac_code}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.description_of_goods}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '34px',
            }}
          >
            {item.uom}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'right',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              minHeight: '34px',
            }}
          >
            {value === "1" ? item.qty : ''}
          </span>
          <input
            type="text"
            className="blue-color"
            name={`${item.name}.taxable_value`}
            value={isManualInputRow ? (item.taxable_value === '' || item.taxable_value === '-' || String(item.taxable_value).endsWith('.') ? item.taxable_value : formatRupee(safeParseFloat(item.taxable_value), true)) : formatRupee(item.taxable_value) || ''}
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'not-allowed',
              minHeight: '34px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.taxable_value || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const stringVal = String(cleanedVal || '');
                const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prevData) =>
                  prevData.map((it) =>
                    it.name === item.name
                      ? { ...it, taxable_value: cleanedVal }
                      : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.concessionalRate}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '34px',
            }}
          >
            {item.rateOfTax}
          </span>
          <input
            type="text"
            className="blue-color"
            name={`${item.name}.igst`}
            value={isManualInputRow ? (item.igst === '' || item.igst === '-' || String(item.igst).endsWith('.') ? item.igst : formatRupee(safeParseFloat(item.igst), true)) : formatRupee(item.igst) || ''}
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'not-allowed',
              minHeight: '34px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.igst || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const stringVal = String(cleanedVal || '');
                const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prevData) =>
                  prevData.map((it) =>
                    it.name === item.name
                      ? { ...it, igst: cleanedVal }
                      : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
          <input
            type="text"
            className="blue-color"
            name={`${item.name}.cgst`}
            value={isManualInputRow ? (item.cgst === '' || item.cgst === '-' || String(item.cgst).endsWith('.') ? item.cgst : formatRupee(safeParseFloat(item.cgst), true)) : formatRupee(item.cgst) || ''}
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'not-allowed',
              minHeight: '34px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.cgst || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const stringVal = String(cleanedVal || '');
                const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prevData) =>
                  prevData.map((it) =>
                    it.name === item.name
                      ? { ...it, cgst: cleanedVal }
                      : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
          <input
            type="text"
            className="blue-color"
            name={`${item.name}.sgst`}
            value={isManualInputRow ? (item.sgst === '' || item.sgst === '-' || String(item.sgst).endsWith('.') ? item.sgst : formatRupee(safeParseFloat(item.sgst), true)) : formatRupee(item.sgst) || ''}
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'not-allowed',
              minHeight: '34px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.sgst || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const stringVal = String(cleanedVal || '');
                const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prevData) =>
                  prevData.map((it) =>
                    it.name === item.name
                      ? { ...it, sgst: cleanedVal }
                      : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
          <input
            type="text"
            className="blue-color"
            name={`${item.name}.cess`}
            value={isManualInputRow ? (item.cess === '' || item.cess === '-' || String(item.cess).endsWith('.') ? item.cess : formatRupee(safeParseFloat(item.cess), true)) : formatRupee(item.cess) || ''}
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'not-allowed',
              minHeight: '34px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.cess || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const stringVal = String(cleanedVal || '');
                const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prevData) =>
                  prevData.map((it) =>
                    it.name === item.name
                      ? { ...it, cess: cleanedVal }
                      : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
        </div>
      );
    });
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <Box sx={{ width: '100%', typography: 'body1', marginBottom: '20px' }}>
            {/* Tab functionality can be added here if needed */}
          </Box>

          <p style={{ marginLeft: '10px', color: '#4D4C4C', marginBottom: '5px' }}>
            Added/Edited HSN details to be saved
          </p>
        </BoxWrapper>

        <div
          style={{
            maxHeight: 'calc(100vh - 450px)',
            overflowY: 'auto',
            overflowX: 'auto',
            marginTop: '10px',
            position: 'relative',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            padding: '0',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 120px 200px 80px 120px 150px 200px 120px 150px 120px 120px 120px',
              gap: '10px',
              alignItems: 'center',
              padding: '12px 10px',
              borderBottom: '2px solid #cbd5e1',
              backgroundColor: '#ffffff',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: 0,
              left: 0,
              zIndex: 20,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              margin: '0',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              minWidth: 'fit-content',
            }}
          >
            <span
              style={{
                textAlign: 'center',
                padding: '8px 6px',
                backgroundColor: '#e0e7ff',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              S.No.
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              HSN Code
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Description
            </span>
            <span
              style={{
                textAlign: 'center',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              UQC
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Total Quantity
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Taxable Value (₹)
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              In supply applicable for concessional rate of tax
            </span>
            <span
              style={{
                textAlign: 'center',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Rate of Tax (%)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Integrated Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Central Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              State/UT Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Cess (₹)
            </span>
          </div>
          <div style={{ padding: '10px', minWidth: 'fit-content' }}>
            {tableData && tableData.length >= 1 ? (
              renderTableRows()
            ) : (
              <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
                No Data Found!
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <button
            type="button"
            className="button-primary"
            onClick={submitHandle}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>
      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />

      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Eighteen;